import { atom } from "recoil";

export interface ISystemAnnouncement {
  id: number;
  message: string;
  isActive: boolean;
  createdBy?: string;
  createdAt?: string;
  updatedAt?: string;
  deactivatedAt?: string | null;
}

export const systemAnnouncementsState = atom<ISystemAnnouncement[]>({
  key: "systemAnnouncementsState",
  default: [],
});
